import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["placeholder", "value"]
const _hoisted_2 = {
  key: 1,
  class: "option-input__label"
}

import { computed, nextTick, ref } from 'vue'

import { QuestionnaireFormOption } from '@/models/onboarding.types'
import OptionInput from './OptionInput.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OptionText',
  props: {
    modelValue: {},
    option: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const textInputValue = ref('')
const inputValue = computed(() => {
  return textInputValue.value || props.option.label
})

const textInputRef = ref<HTMLInputElement | null>(null)
const isTextInputActive = ref(false)

function updateValue(): void {
  const input = textInputRef.value
  if (!input) {
    return
  }

  textInputValue.value = input.value
  emit('update:modelValue', [inputValue.value])
}

async function showTextInput(): Promise<void> {
  isTextInputActive.value = true

  await nextTick()
  if (!textInputRef.value) {
    return
  }

  textInputRef.value.focus()
  updateValue()
}

function hideTextInput(): void {
  isTextInputActive.value = false
  updateValue()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OptionInput, {
    type: "radio",
    value: inputValue.value,
    modelValue: __props.modelValue,
    updateFn: updateValue,
    hideInput: isTextInputActive.value,
    option: __props.option,
    class: "option-input--text",
    onClick: showTextInput
  }, {
    default: _withCtx(() => [
      (isTextInputActive.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            ref_key: "textInputRef",
            ref: textInputRef,
            type: "text",
            class: "option-input__label option-input__label--text-input",
            placeholder: __props.option.placeholder,
            value: textInputValue.value,
            onInput: updateValue,
            onBlur: hideTextInput
          }, null, 40, _hoisted_1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(inputValue.value), 1))
    ]),
    _: 1
  }, 8, ["value", "modelValue", "hideInput", "option"]))
}
}

})